import { render, staticRenderFns } from "./ViewEdit.vue?vue&type=template&id=8337caf8&lang=html&"
import script from "./ViewEdit.vue?vue&type=script&lang=js&"
export * from "./ViewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports